const filteringSkin = {
  "filtering-row": {
    composes: "row",
    "padding-top": "10px",
    "padding-bottom": "10px",
  },
};

export default filteringSkin;
